/* eslint-disable no-use-before-define */
import React, {useEffect} from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import connect from "react-redux/es/connect/connect";
import PneuFabricanteDialog from "./pneuFabricanteDialog";
import {useSelector} from "react-redux";

const filter = createFilterOptions();

const   PneuFabricanteSelector = ({

                                    onChange,
                                    defaultValue

                                }) => {

    const PneuFabricantes  = useSelector(state =>  state.tires.fabricantes && state.tires.fabricantes.data ? state.tires.fabricantes.data : []);
    const [value, setValue] = React.useState(defaultValue || null);
    const [dialogOpen, setDialogOpen] = React.useState(false)
    const [dialogValue, setDialogValue] = React.useState({
        descricao: '',
        // year: '',
    });

    useEffect( () => {
        //console.log('PneuFabricanteSeletor.useEffect.defaultValue changed', defaultValue);
        const ix = PneuFabricantes.findIndex( f => f.id === defaultValue);
            if (ix >= 0) {
                setValue(PneuFabricantes[ix].descricao);
            }

        // console.log("useEffect 1", isAddNewRecord, addNewRecord, open, isOpen);
    }, [ defaultValue ]);

    const onAutocompleteChange = (event, newValue) => {
        //console.log(" onAutocompleteChange newvalue", newValue)
        if (typeof newValue === 'string') {
            // timeout to avoid instant validation of the dialog's form.
            setTimeout(() => {
                setDialogOpen(true);
                setDialogValue({
                    descricao: newValue
                    // year: '',
                });
               // console.log('onAutocompleteChange fD.1');
                onChange(newValue);
            });
        } else if (newValue && newValue.inputValue) {
            setDialogOpen(true);
            setDialogValue({
                title: newValue.inputValue,
                // year: '',
            });
            //console.log('onAutocompleteChange fD.2');
            onChange(newValue);
        } else {
            setValue(newValue);
            //console.log('onAutocompleteChange fD.3');
            onChange(newValue);
        }
    }

   // console.log("fabricanteSelector", PneuFabricantes);
   // console.log("fabricanteSelector value", value);

    return (
        <React.Fragment>
            <Autocomplete
                value={value}
                onChange={ (event, newValue, reason, details) => {
                    //console.log("fabricanteSelector onchange", newValue);
                    onAutocompleteChange(event, newValue);
                 }}
                filterOptions={(options, params) => {
                   // console.log("filterOptions", options, params);
                    const filtered = filter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            inputValue: params.inputValue,
                            descricao: `Add "${params.inputValue}"`,
                        });
                    }

                    return filtered;
                }}
                id="pneuFabricante"
                options={PneuFabricantes}
                getOptionLabel={(option) => {
                    // e.g value selected with enter, right from the input
                   // console.log("fabricanteSelector getOPtinLabel [", option,"]");
                    if (typeof option === 'string') {
                       // console.log(" fabricanteSelector getOptionLabel string [", option,"]");
                        return option;
                    }
                    if (option.inputValue) {
                        //console.log("fabricanteSelector getOptionLabel inputvalue [", option,"]");
                        return option.inputValue;
                    }
                    //console.log("getOptionLabel descricao [", option,"]");
                    if (option && option.descricao) {
                        return option.descricao;
                    } else {
                        return '';
                    }
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                renderOption={(option) => option.descricao}
                style={{ //width: 300
                     }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} label="Fabricante" />
                            )}
            />
            <PneuFabricanteDialog open={dialogOpen}
                                  onClose={() => setDialogOpen(false)}
                                  value={dialogValue}

            />

        </React.Fragment>
);
}


export default (PneuFabricanteSelector)


